import { useQuery } from '@tanstack/react-query';
import { getUserOrg } from '../helpers/user';
import { killshotApi } from '../api';

const fetchEventTourInfo = async skyboxId => {
  const response = await killshotApi.get(`v1/event/tour/${skyboxId}`);
  return response;
};

const fetchAllMyEvents = async (user, type) => {
  const response = await killshotApi.get(`v1/event/analyst/${user}/${type}`);
  return response;
};

const fetchUserTypes = async userType => {
  const response = await killshotApi.get(`v1/analyst/${userType}`);
  return response;
};

export const useQueryEventTour = eventId => {
  const { data, isFetching, status, error, refetch } = useQuery({
    queryKey: [`/event/tour/${eventId}`, getUserOrg()],
    queryFn: () => fetchEventTourInfo(eventId),
    refetchOnWindowFocus: false,
    enabled: !!eventId,
  });
  return {
    data,
    isFetching,
    status,
    error,
    refetch,
  };
};

export const userQueryMyEvents = (user, type) => {
  const { data, isFetching, status, error, refetch } = useQuery({
    queryKey: [`/event/analyst/${user}/${type}`, getUserOrg()],
    queryFn: () => fetchAllMyEvents(user, type),
    refetchOnWindowFocus: false,
    enabled: !!user,
    staleTime: 1000 * 60 * 2, // 2 minutes
  });
  return {
    data,
    isFetching,
    status,
    error,
    refetch,
  };
};

export const userQueryGetUsersByType = userType => {
  const { data, isFetching, status, error, refetch } = useQuery({
    queryKey: [`/event/analyst/${userType}`, getUserOrg()],
    queryFn: () => fetchUserTypes(userType),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 2, // 2 minutes
  });
  return {
    data,
    isFetching,
    status,
    error,
    refetch,
  };
};
